import React, { useEffect } from 'react';
import {Link} from 'react-router-dom';
import {Button} from 'antd';
import styles from './index.module.less';
import { t } from "i18next";
import { axios } from "common";

export default (props) => {
    const {errorCode = 404} = props;

    const errorCodeDescription = {
        403: t("notHaveAccess"),
        404: t("PageLost")
    }

    const goStore = () => {
        props.history.push("/unifyDrop/myShop/list");
    }

    const oauthLogin = () =>  {
        let href = window.location.href;
        let startIndex = href.indexOf("/?customState=");
        if (startIndex > -1) {
            const params = href.substring(startIndex + 1);
            if (params) {
                axios.get('/biz/shop/authShopByCustomState'+params)
                goStore()
            }
        }
    }

    useEffect(() => {
        if (localStorage.getItem("authorization") || sessionStorage.getItem("authorization")) {
            if (window.location.href.indexOf("/?")>-1) {
                oauthLogin()
            }
        }
    }, [])

    return (
        <div className={styles.box}>
            <div className={styles.content}>
                <div className={`iconfont accident ${styles.iconBg}`}>
                    <span className={styles.errTxt}>{errorCode}</span>
                </div>
                <div className={styles.description}>
                    <big>{t("MakeMistake")}</big>
                    <p>{errorCodeDescription[errorCode]}</p>
                    <Link to='/login'><Button type="primary">{t("logInAgain")}</Button></Link>
                </div>
            </div>
        </div>
    )
}
